
export const ST_APP_INDEX_REQUEST = 'ST_APP_INDEX_REQUEST';
export const ST_APP_INDEX_SUCCESS = 'ST_APP_INDEX_SUCCESS';
export const ST_APP_INDEX_ERROR = 'ST_APP_INDEX_ERROR';

export const ST_APP_DETAIL_REQUEST = 'ST_APP_DETAIL_REQUEST';
export const ST_APP_DETAIL_SUCCESS = 'ST_APP_DETAIL_SUCCESS';
export const ST_APP_DETAIL_ERROR = 'ST_APP_DETAIL_ERROR';
